import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueI18n from 'vue-i18n';
import {extend, configure, setInteractionMode} from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import {VueMaskDirective} from 'v-mask';

/** Styles **/
import 'sweetalert2/dist/sweetalert2.min.css';
import '~/scss/main.scss';

/** Translations */
import pt from './i18n/pt'
import {pt as vuetifyMessages} from 'vuetify/lib/locale';
import {messages as veeMessages} from 'vee-validate/dist/locale/pt_BR.json';

/** Validation rules to VeeValidate */
import * as rules from 'vee-validate/dist/rules';

Vue.use(Vuetify, {options: {customProperties: true}});
Vue.use(VueI18n);
Vue.use(VueSweetalert2);
Vue.directive('mask', VueMaskDirective);

setInteractionMode('eager')

/** Merge all messages from Vuetify, VeeValidate, local */
const messages = Object.assign({}, pt, {
    $vuetify: vuetifyMessages,
    fields: pt.label,
    validation: veeMessages
});

/** Set messages on VueI18n */
const i18n = new VueI18n({
    locale: 'pt',
    fallbackLocale: 'pt',
    messages: {
        pt: messages
    },
    modifiers: {
        single: (str) => i18n.tc(str),
        snakeCase: (str) => str.split(' ').join('-')
    }
});

/**
 * Configure VeeValidate to translate field names and validation messages
 * Overrides the field name.
 * @NOTE: Only works when the "extend" function don't set the "message" option
 */
configure({
    defaultMessage: (field, values) => {
        values._field_ = i18n.t(`fields.${field}`).toLowerCase();
        return i18n.t(`validation.${values._rule_}`, values);
    }
});

/**
 * Set all messages to default VeeValidate rules
 * @NOTE: don't use "extend+message" while using "configure" above. ex: "message: veeMessages[rule]"
 */
Object.keys(rules).forEach(rule => {
    extend(rule, {
        ...rules[rule],
        //message: some string
    });
});

/** Configure Vuetify to use VueI18n */
export default new Vuetify({
    lang: {
        locales: {pt},
        current: 'pt',
        t: (key, ...params) => i18n.t(key, params),
    },
});

export {i18n};